import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Card } from '../ui/Card';
import { Lock, Zap, Wind, MapPin, ArrowUpCircle, Package, Activity, Share2, Shield, History } from 'lucide-react';
export function FeatureGrid() {
  const features = [{
    icon: Lock,
    title: 'Türen öffnen & schließen',
    desc: 'Volle Kontrolle über Verriegelung per App.'
  }, {
    icon: Zap,
    title: 'Fernstart des Motors',
    desc: 'Motor aus der Ferne starten oder stoppen.'
  }, {
    icon: Wind,
    title: 'Klimaanlage (A/C)',
    desc: 'Fahrzeug vorheizen oder vorkühlen.'
  }, {
    icon: MapPin,
    title: 'Fahrzeugortung',
    desc: 'GPS-Position in Echtzeit finden.'
  }, {
    icon: ArrowUpCircle,
    title: 'Fenstersteuerung',
    desc: 'Fenster remote öffnen oder schließen.'
  }, {
    icon: Package,
    title: 'Kofferraum',
    desc: 'Heckklappe per Smartphone öffnen.'
  }, {
    icon: Activity,
    title: 'Fahrzeugstatus',
    desc: 'Tank, Batterie, Temperatur prüfen.'
  }, {
    icon: Share2,
    title: 'Key Sharing',
    desc: 'Zugang digital an andere vergeben.'
  }, {
    icon: Shield,
    title: 'Auto Lock/Unlock',
    desc: 'Entriegelt bei Annäherung automatisch.'
  }, {
    icon: History,
    title: 'Fahrtenhistorie',
    desc: 'Protokoll aller Fahrten und Zugriffe.'
  }];
  return <section className="py-24 bg-[#0f0f16]" data-id="element-128">
      <div className="container mx-auto px-4 md:px-6" data-id="element-129">
        <SectionHeading title="Alles, was Sie brauchen – direkt auf dem Smartphone" subtitle="Umfassende Kontrolle über alle wichtigen Fahrzeugfunktionen in einer App." align="center" data-id="element-130" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-131">
          {features.map((feature, index) => <Card key={index} className="flex flex-col items-start h-full" data-id="element-132">
              <div className="w-12 h-12 bg-cyan-500/10 rounded-lg flex items-center justify-center mb-4 text-cyan-400" data-id="element-133">
                <feature.icon className="w-6 h-6" data-id="element-134" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-135">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-136">
                {feature.desc}
              </p>
            </Card>)}
        </div>
      </div>
    </section>;
}